import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsIFrame, setTestRideDealerId } from '@yme/components/TestRide/redux/actions';
import { getTestRideDealerId, getTestRideIframe } from '@yme/components/TestRide/redux/selectors';
export function useTestRideDealerDispatch({ dealerIdFromUrl, isIframeFromUrl, }) {
    const dealerId = useSelector(getTestRideDealerId);
    const isIframe = useSelector(getTestRideIframe);
    const dispatch = useDispatch();
    useEffect(() => {
        if (dealerIdFromUrl && dealerIdFromUrl !== dealerId) {
            dispatch(setTestRideDealerId(dealerIdFromUrl));
        }
        if (isIframe !== isIframeFromUrl) {
            dispatch(setIsIFrame(isIframeFromUrl));
        }
    }, [dealerIdFromUrl, isIframeFromUrl, dealerId, isIframe, dispatch]);
}
